<template>
<nav class="navbar navbar-expand-md navbar-expand navbar-dark main-header bg-white navbar-light border-bottom">
 <div class="d-flex justify-content-between container-fluid">
    <div class="headtoplogo">
      
        
        <router-link :to="{ name: 'dashboard',params: { ic: 1 }}" v-if="$gate.loginUser().type=='ceo'"><img src="./../../img/logo_new_top.png" alt="The Logo" class="brand-image mb-0"></router-link>
   <router-link to="/dashboard" v-else><img src="./../../img/logo_new_top.png" alt="The Logo" class="brand-image mb-0"></router-link>
  <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
    <span class="navbar-toggler-icon"></span>
  </button> --></div>
    <div class="header-top-onlb col-md-5" v-if="$gate.loginUser().uic_validate==1 && ($gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student')"><div class="align-self-center brand-top" id="myNavbar">
                  <select class='form-control btn-sm' v-model="current_school_id" @change="updateMyCurrSchool(current_school_id)" v-if="schools.length>1">
                                <option :value="0">Please select an option</option>
                                <option  v-for="(item,index) in schools" :value="item.id" :key="index">{{item.name}}</option>
                    </select>
                </div></div>
                
    <div class="header-top-onlb"> <div class="collapse navbar-collapse pt-nav pt-nav d-flex justify-content-end" id="collapsibleNavbar">
               <div class="bord align-self-center brand-top border-right border-left-0 hideinmob"  v-if="$gate.loginUser().uic_validate==1">
                <label class="m-0"> Academic Year</label>
                <select class='btn-sm' v-model="current_year" @change="updateMyCurrYear(current_year)" v-if="$gate.loginUser().academic_year_type=='oneyear'">
                    <option  :value="2024">2024-2025</option>
                    <option  :value="2023">2023-2024</option>
                    <option  :value="2022">2022-2023</option>
                </select>
                <select class='btn-sm' v-model="current_year" @change="updateMyCurrYear(current_year)" v-else>
                    <option  :value="2024">2024-2025</option>
                    <option  :value="2023">2023-2024</option>
                    <option  :value="2022">2022-2023</option>
                </select>
                
                </div>
                <div class="bord align-self-center brand-top border-0"  v-if="$gate.loginUser().uic_validate==1">
                <!-- <img src="./../../img/globe.png" alt="User" class="img-w"> -->
                 <translate></translate>
                </div>
                          
                <!-- <div class="bord align-self-center pl-e brand-top"   v-if="$gate.loginUser().uic_validate==1">
                    <img src="./../../img/anyque.png" alt="User"  class="img-w ">
                </div> -->
                <div class="bord align-self-center relative brand-top pointer hideinmob"  v-if="$gate.loginUser().uic_validate==1">
                       <a id="dLabel" role="button" data-toggle="dropdown" data-target="#" @click="genotificationDataInPop()">
                            <div class="counts-notic"><p>{{notif}}</p></div>
                            <img src="./../../img/bellnot.png" alt="User">
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right notifications pt-0 pb-0" role="menu" aria-labelledby="dLabel">
                            <div class="notification-heading wt-6 ft-15 border-bottom bg-light">Notifications</div>
                            <li class="divider"></li>
                            <div class="notifications-wrapper">
                                <div v-for="item in popNotif">
                                <a class="content" href="#" v-for="list in item" v-if="item.length>0">
                                <div class="notification-item">
                                    <router-link :to="'/assignment/view/'+list.type_uuid" v-if="list.type=='assignment' || list.type=='grade' || list.type=='submission'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/course/view/'+list.type_uuid" v-if="list.type=='course'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/announcements'" v-if="list.type=='announcement'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/invitations'" v-if="list.type=='invitation'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/dashboard'" v-if="list.type=='snap'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/units'" v-if="list.type=='unit'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/lessons'" v-if="list.type=='lesson'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/schoolorg/view/'+list.type_uuid" v-if="list.type=='org'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/school/view/'+list.type_uuid" v-if="list.type=='school'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <router-link :to="'/share'" v-if="list.type=='share'"><p class="m-0 ft-13 pointer" @click="seenData(1,list.id)" @contextmenu.prevent="seenData(1,list.id)">{{ list.description| truncate(50, '...')}} By {{list.created_by_name}} ({{list.created_by_type}})</p></router-link>
                                    <p class="m-0 text-secondary ft-11"><span class="wt-6">Type - </span> {{list.type}} at {{list.shedule_dt}}</p>
                                </div>
                                </a>
                                </div>
                            </div>
                            <li class="divider"></li>
                            <div class="notification-footer ft-14 text-center wt-6 bg-light">
                                <router-link to="/notifications" class="nav-link p-0">View all</router-link>
                            </div>
                        </ul>
                    </div>
                
                
                <!--   <div class="pl-2 bord align-self-center brand-top" v-if="$gate.loginUser().uic_validate==1">
                <img :src="$gate.loginUser().file"  style="width:30px;height:30px" v-if="$gate.loginUser().file !=null && $gate.loginUser().file !=''">
                  <img src="./../../img/def_user.png"  v-else> 
                   <img src="./../../img/def_user.png" alt="def_user" class="img-w" />
                </div>-->    

                <div class="dropdown bord p-0">
                    <span class="btn btn-default dropdown-toggle btn-header" type="button" data-toggle="dropdown">
                        <img :src="'/'+$gate.loginUser().file" class="heade_prof_img" v-if="$gate.loginUser().file !=null">
                        <img src="./../../img/def_user.png" alt="def_user"  v-else>
                    <span class="caret"></span></span>
     
     <ul class="dropdown-menu dropdown-menu-right">            
                <div class="dropdown-menu-right">
                      <li class="text-center"><span><b> {{$gate.loginUser().name}}</b></span></li>
      <hr/>       

      <div class="subprof ft-13 text-secondary pt-1">  {{$gate.loginUser().type}}</div>
               
                <router-link to="/profile" v-if="$gate.loginUser().uic_validate==1">
                    <button class="dropdown-item" type="button">
                    <i class="nav-icon fas fa-user green"></i>  My Profile
                    </button>
                </router-link>
               
                <button class="dropdown-item" type="button">
                <a href="#" onclick="event.preventDefault(); document.getElementById('logout-form').submit();">
                    <i class="nav-icon fas fa-power-off red"></i>
                      Logout
                    </a>
                    <form id="logout-form"  :action="$gate.BaseUrl()+'logout'" method="POST" style="display: none;">
                        @csrf
                    <input type="hidden" name="_token" :value="csrf">
                    </form>
                </button>
                </div>
    </ul>
  </div>
          <div class="pl-2  align-self-center item-css" v-if="$gate.loginUser().uic_validate==1">
                
            <div class="btn-group">
            <span type="button" class="p-0 btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img src="./../../img/menu.png" alt="Menu">
            </span>
            <div class="dropdown-menu dropdown-menu-right">
            <div class="land-new-pop">
                <div class="row" v-if="menus.length>0">
                   
                <div class="col-sm-3 new-landing-avtar menus" v-for="item in menus">
                    <div class="p-1 topmenuhover contentdiv" v-if="item.params=='schoolorg/view'">
                        <router-link to="#" class="nav-link pointer"> <div class="content-overlay" @click="showSchoolOrg()"></div></router-link>
                       <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img">
                        <div class="land-menu-name" @click="getRoute()"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                          <input type="text" class="icon1"  title="Remove from Fav" @click="favFun(0,item.id)" v-if="item.fav">
                          <input type="text" class="icon"  title="Add to Fav" @click="favFun(1,item.id)" v-else>

                        </div>
                    </div>
                    <div class="p-1 topmenuhover contentdiv" v-else-if="item.params=='school/view'">
                        <router-link to="#" class="nav-link pointer"><div class="content-overlay" @click="showSchool()"></div></router-link>
                       <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                          <input type="text" class="icon1"  title="Remove from Fav" @click="favFun(0,item.id)" v-if="item.fav">
                          <input type="text" class="icon"  title="Add to Fav" @click="favFun(1,item.id)" v-else>

                        </div>
                    </div>
                    <div class="p-1 topmenuhover contentdiv" v-else-if="item.params=='courses' && $gate.loginUser().type=='admin'">
                        <router-link to="/worldcourse" class="nav-link pointer"><div class="content-overlay"></div></router-link>
                       <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                          <input type="text" class="icon1"  title="Remove from Fav" @click="favFun(0,item.id)" v-if="item.fav">
                          <input type="text" class="icon"  title="Add to Fav" @click="favFun(1,item.id)" v-else>

                        </div>
                    </div>
                    <div class="p-1 topmenuhover contentdiv" v-else-if="item.params=='course/gradebook' && $gate.loginUser().type=='student'">
                        <router-link to="/student/gradebook" class="nav-link pointer"><div class="content-overlay"></div></router-link>
                       <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                          <input type="text" class="icon1"  title="Remove from Fav" @click="favFun(0,item.id)" v-if="item.fav">
                          <input type="text" class="icon"  title="Add to Fav" @click="favFun(1,item.id)" v-else>

                        </div>
                    </div>
                    <div class="p-1 topmenuhover contentdiv" v-else-if="item.params=='nation'">
                        <router-link to="#" class="nav-link pointer"><div class="content-overlay" @click="getRoute()"></div></router-link>
                       <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                          <input type="text" class="icon1"  title="Remove from Fav" @click="favFun(0,item.id)" v-if="item.fav">
                          <input type="text" class="icon"  title="Add to Fav" @click="favFun(1,item.id)" v-else>

                        </div>
                    </div>
                    <div class="p-1 topmenuhover contentdiv" v-else>
                        <router-link :to="'/'+item.params" class="nav-link pointer"><div class="content-overlay"></div></router-link>
                       <img :src="'/images/menu/'+item.icon" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>{{ item.name }}</div></div>
                        <div class="content-details fadeIn-bottom" >
                          <input type="text" class="icon1"  title="Remove from Fav" @click="favFun(0,item.id)" v-if="item.fav">
                          <input type="text" class="icon"  title="Add to Fav" @click="favFun(1,item.id)" v-else>

                        </div>
                    </div>
                  </div>
                 
                </div>
                <div class="row" v-else>
                <div class="col-sm-12 p-5 text-center ft-16">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
            <!-- <div class="row">
                <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg'">
                    <a  class="nav-link pointer" @click="getRoute()">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/own.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name" v-if="$gate.loginUser().type=='admin'"><div>My World</div></div>
                        <div class="land-menu-name" v-if="$gate.loginUser().type=='gov'"><div>My Nation</div></div>
                        <div class="land-menu-name" v-if="$gate.loginUser().type=='reg'"><div>My Region</div></div>
                        </div>
                      </a>
                    </div>
                <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/attendance" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/attendance.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Attendance</div></div>
                        </div>
                        </router-link>
                    </div>
                <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/userdashboard" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/icon-dashboard.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Dashboard</div></div>
                        </div>
                        </router-link>
                </div>
                <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher'">
                    <router-link to="/course/gradebook" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/grade-book.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Gradebooks</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='student'">
                    <router-link to="/student/gradebook" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/grade-book.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Gradebook</div></div>
                        </div>
                        </router-link>
                    </div>
                <div class="col-sm-3 new-landing-avtar">
                    <router-link to="/invitations" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/vertual.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Invitations</div></div>
                        </div>
                        </router-link>
                    </div>
              <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/users" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/managment.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Manage User</div></div>
                        </div>
                        </router-link>
                    </div>
                <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/projectassignments/2" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/showcase.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Project Assignments</div></div>
                        </div>
                        </router-link>
                </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg'">
                    <router-link to="/schoolorgs" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/schoolsystem.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>School Organization</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='ceo'">
                    <a class="nav-link pointer" @click="showSchoolOrg()">
                        <div class="p-1 topmenuhover">
                        <img src="./../../img/menus/schoolsystem.png" alt="Menu">
                        <div class="land-menu-name"><div>My Organization</div></div>
                        </div>
                        </a>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo'" >
                    <router-link to="/schools" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/school.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Schools</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='principal'" >
                    <a class="nav-link pointer" @click="showSchool()">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/school.png" alt="Menu">
                        <div class="land-menu-name"><div>My Schools</div></div>
                        </div>
                        </a>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher'">
                    <router-link to="/questioncreate" class="nav-link">
                    <div class="p-1 topmenuhover">
                   <img src="./../../img/menus/dailyQue.png" alt="Menu">
                        <div class="land-menu-name"><div>Snap Shot</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='student'">
                    <router-link to="/dailyQueScore" class="nav-link">
                    <div class="p-1 topmenuhover">
                   <img src="./../../img/menus/viewscore.png" alt="Menu">
                        <div class="land-menu-name"><div>Snap Shot Data</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher'">
                    <router-link to="/planner" class="nav-link">
                    <div class="p-1 topmenuhover">
                   <img src="./../../img/menus/planner.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Planner</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar">
                    <router-link to="/announcements" class="nav-link">
                    <div class="p-1 topmenuhover">
                   <img src="./../../img/menus/announcement.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Announcements</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/assignments/0" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/assignment.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Assignments</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher'">
                    <router-link to="/bestpractice" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/bestp.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Best Practices</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin'">
                    <router-link to="/worldcourse" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/course.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Courses</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/courses" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/course.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Courses</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin'">
                    <router-link to="/department" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/department.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Departments</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher'">
                    <router-link to="/genius" class="nav-link">
                    <div class="p-1 topmenuhover">
                   <img src="./../../img/menus/genius_finder.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Genius Finder</div></div>
                        </div>
                        </router-link>
                    </div> 
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin'">
                    <router-link to="/gradelevel" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/managment.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Gradelevels</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/lessons" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/lesson.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Lessons</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/notifications" class="nav-link">
                    <div class="p-1 topmenuhover">

                      <img src="./../../img/menus/alert.png" alt="Menu">
                        <div class="land-menu-name"><div>Notification</div></div>
                          </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/performancealert" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/performance-alert.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Progress Monitoring</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/recommendation" class="nav-link">
                    <div class="p-1 topmenuhover">

                      <img src="./../../img/menus/recommendation.png" alt="Menu">
                        <div class="land-menu-name"><div>Recommendation</div></div>
                          </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='student'">
                    <router-link to="/cal" class="nav-link">
                     <div class="p-1 topmenuhover">
                      <img src="./../../img/menus/calendar.png" alt="Menu">
                        <div class="land-menu-name"><div>My Calendar</div></div>
                          </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin'">
                    <router-link to="/schoolprograms" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/gradelevel.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>School Program</div></div>
                        </div>
                        </router-link>
                    </div>
                    <div class="col-sm-3 new-landing-avtar">
                    <router-link to="/share" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/share.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Shared File</div></div>
                        </div>
                        </router-link>
                    </div>
                    
                    
                   
                   
                   
                 
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher' || $gate.loginUser().type=='student'">
                    <router-link to="/units" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/unit.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>Units</div></div>
                        </div>
                        </router-link>
                    </div>
                   
                    <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin' || $gate.loginUser().type=='gov' || $gate.loginUser().type=='reg' || $gate.loginUser().type=='ceo' || $gate.loginUser().type=='principal' || $gate.loginUser().type=='teacher'">
                    <router-link to="/recyclebin" class="nav-link">
                     <div class="p-1 topmenuhover">
                      <img src="./../../img/menus/recycle.png" alt="Menu">
                        <div class="land-menu-name"><div>Recycle bin</div></div>
                          </div>
                        </router-link>
                    </div>
                   
                          
                    
                    
                
                    
                    
                   
                    
                    
                
                    
                   
                    
                    
                 <div class="col-sm-3 new-landing-avtar" v-if="$gate.loginUser().type=='admin'">
                    <router-link to="/#" class="nav-link">
                    <div class="p-1 topmenuhover">
                    <img src="./../../img/menus/csv.png" alt="Menu" class="menu-img">
                        <div class="land-menu-name"><div>CSV Upload</div></div>
                        </div>
                        </router-link>
                    </div> 
                    
            </div> -->
            </div>
            </div>
            </div>
          </div>
            </div>
  </div>
  </div>
 
 
 
 
   
</nav>
  </template> 
<script>
  $(function () {
  $('[data-toggle="tooltip"]').tooltip();
  $(document).click(function()
    {
    $("#notificationContainer").hide();
    });
})
</script>
<script>
$(document).ready(function()
    {
   //Popup on click
    $("#notificationContainer").click(function()
    {
    return false;
    });

    $('#myDD').on('hide.bs.dropdown', function (e) {
    if (e.clickEvent) {
      e.preventDefault();
    }
});
    
});
</script>

<script>
import translate from "./translate";
    export default {
        components: {
          // translate: () => import("./translate.vue"),
          "translate":translate
        },
         data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                schools:[],
                current_school_id:0,
                schoolInfo:null,
                schoolOrgInfo:null,
                notif:0,
                popNotif:[],
                menus:[],
                interval:null,
                current_year:2022
            }
            },
            created() {
                this.showMenus();
                this.$eventHub.$on("successfullyaddedmenutofavfromdash", () => {
                    this.showMenus();
                });
            },
            filters: {
               truncate: function (text, length, suffix) {
                  return text.substring(0, length) + suffix;
                },
            },
            mounted(){
                if(this.$gate.loginUser().type=='principal' || this.$gate.loginUser().type=='teacher' || this.$gate.loginUser().type=='student'){
                    this.getMySchools()
                }
                this.current_year=this.$gate.loginUser().current_year;
                this.geUnSeenNotiData();
                this.interval = setInterval(function () {
                    this.geUnSeenNotiData();
                    }.bind(this), 30000);
                },
             beforeDestroy: function(){
                clearInterval(this.interval);
            },
            methods: {
            submit : function(){
                this.$refs.form.submit();
            },
            getRoute(){
                if (this.$gate.loginUser().type=='admin') {
                    this.$router.push('/myworld')
                } else if(this.$gate.loginUser().type=='gov') {
                 this.showSchoolOrgByGov(this.$gate.loginUser().own_org)
                }else{
                    this.getGovNations();
                }
            },
            getGovNations(){   
                axios.get(this.$gate.BaseUrl()+"api/govnation/")
                .then(response => {
                    this.govNation=response.data.data;
                    if(this.govNation !=null){
                        this.$router.push('/schoolorg/view/'+this.govNation.uuid);
                    }
                 })
             },
            showSchool(){   
                axios.get(this.$gate.BaseUrl()+"api/showsch/"+this.$gate.loginUser().current_school)
                .then(response => {
                    this.schoolInfo=response.data.data;
                    if(this.schoolInfo !=null){
                        this.$router.push('/school/view/'+this.schoolInfo.uuid);
                    }
                 })
             },
             showSchoolOrg(){   
                this.schoolOrgInfo=null; 
                axios.get(this.$gate.BaseUrl()+"api/showschorg/"+this.$gate.loginUser().current_school_org)
                .then(response => {
                    this.schoolOrgInfo=response.data.data;
                    if(this.schoolOrgInfo !=null){
                        this.$router.push('/schoolorg/view/'+this.schoolOrgInfo.uuid);
                    }
                 })
             },
             showSchoolOrgByGov(id=0){
                this.schoolOrgInfo=null;   
                axios.get(this.$gate.BaseUrl()+"api/showschorg/"+id)
                .then(response => {
                    this.schoolOrgInfo=response.data.data;
                    if(this.schoolOrgInfo !=null){
                        this.$router.push('/schoolorg/view/'+this.schoolOrgInfo.uuid);
                    }
                 })
             },
            getMySchools(){
                this.schools=[]; 
                axios.get(this.$gate.BaseUrl()+"api/assignedsch")
                .then(response => {
                this.schools = response.data.data;
                this.current_school_id=this.$gate.loginUser().current_school;
                }).catch(error => {console.log(error)
                this.errored = true
                }) 
                .finally(() => this.loading = false)
                },
            updateMyCurrSchool(school_id=0){
                axios.get(this.$gate.BaseUrl()+"api/upcursch",{params:{school_id:school_id}})
                .then(response => {
                    var url = window.location.pathname;
                    window.location.href = this.$gate.BaseUrlWithoutSlash()+url;

                 }).catch(error => {console.log(error) }).finally(() => this.loading = false)
                },
            updateMyCurrYear(current_year=0){
                axios.get(this.$gate.BaseUrl()+"api/upcuryear",{params:{current_year:current_year}})
                .then(response => {
                    var url = window.location.pathname;
                    window.location.href = this.$gate.BaseUrlWithoutSlash()+url;

                 }).catch(error => {console.log(error) }).finally(() => this.loading = false)
                },
            geUnSeenNotiData(){
                axios.get(this.$gate.BaseUrl()+"api/unsn",{params:{pop:1}})
                .then(response => {
                    this.notif=response.data.data;
                 }).catch(error => {console.log(error.message)
                    if(error.message==='Request failed with status code 401'){
                        var url = window.location.pathname;
                        window.location.href = this.$gate.BaseUrlWithoutSlash()+url;
                    }
                }).finally(() => this.loading = false)
                },
            gePopNotiData(){
                axios.get(this.$gate.BaseUrl()+"api/popnoti")
                .then(response => {
                    this.popNotif=response.data.data;
                 }).catch(error => {console.log(error) }).finally(() => this.loading = false)
                },
            showMenus(){   
                axios.get(this.$gate.BaseUrl()+"api/menu")
                .then(response => {
                    this.menus=response.data.data;
                 })
             },
             favFun(type,id){
              console.log(id);
              axios.post(this.$gate.BaseUrl()+'api/fav',{type:type,id:id})
                                .then((response)=>{
                                    this.$eventHub.$emit("successfullyaddedmenutofav");
                                    this.showMenus();
                                }).catch((data)=> {});
             },
            genotificationPop(){
                $("#notificationContainer").fadeToggle(300);
                $("#notification_count").fadeOut("slow");
                return false;
            },
            genotificationDataInPop(){
                this.gePopNotiData();
            },
            seenData(pop=0,id=0){
              axios.post(this.$gate.BaseUrl()+'api/notiseen',{pop:pop,id:id})
                                .then((response)=>{
                                    this.geUnSeenNotiData();
                                }).catch((data)=> {});
            },
            }

    }
     
</script>
<style scoped>


.notifications {
   min-width:420px; 
  }
  
  .notifications-wrapper {
     overflow:auto;
      max-height:400px;
    }
 .notification-heading, .notification-footer  {
 	padding:2px 10px;
       }
      
        
.dropdown-menu.divider {
  margin:5px 0;          
  }


.notifications a.content {
 text-decoration:none;
 background:#ccc;

 }
    
.notification-item {
 padding:10px;
 border-bottom: 1px solid #ccc
 }

 .icon {
  padding-left: 5px;
  background: url("./../../img/menus/heart.png") no-repeat left;
  background-size: 20px;
  width: 20px;
    border: 0;
    float: right;
    text-align: center;
    cursor: pointer;
}
.icon1 {
  padding-left: 5px;
  background: url("./../../img/menus/unheart.png") no-repeat left;
  background-size: 20px;
  width: 20px;
    border: 0;
    float: right;
    text-align: center;
    cursor: pointer;
}
.icon1:focus{outline: none;}
.icon:focus{outline: none;}
</style>